/**
 * The 🐱 used to have a per-symbol threshold (`vest-cat-settings`, persist
 * v1-v3: "raw Vest volume >= X% of CME volume"). Since #599 the cat fires when
 * the Vest bar visibly sticks out above the CME bar in the volume pane, so the
 * threshold drives nothing. Its on/off toggle always lived in levelsStore
 * (`vestCat`) and is untouched. This drops the dead blob once, at startup.
 */
export const LEGACY_VEST_CAT_SETTINGS_KEY = 'vest-cat-settings';

type KeyStorage = Pick<Storage, 'getItem' | 'removeItem'>;

/** Remove the old threshold blob; true when one was there. Never throws. */
export function dropLegacyVestCatSettings(storage?: KeyStorage | null): boolean {
  try {
    const s = storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
    if (!s || s.getItem(LEGACY_VEST_CAT_SETTINGS_KEY) === null) return false;
    s.removeItem(LEGACY_VEST_CAT_SETTINGS_KEY);
    return true;
  } catch {
    return false; // storage blocked (private mode, sandbox): nothing to clean
  }
}
